// extracted by mini-css-extract-plugin
export default {"modalFixed":"Modal_modalFixed__Mol1-"};